:host {
  display: block;
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 0;
  overflow: hidden;
  top: 0;
  padding: 30px 40px 40px;
}

:host(.active) {
  border: 1px solid var(--skin-color-secondary, $ui-grey);
  margin-top: -1px;
  opacity: 1;
  position: relative;
  z-index: 10;
  height: auto;
  background: var(--skin-color-white, $ui-white);
}
